import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SignUpFormName } from '../routes/user/form/SignUpFormName';
import { SignUpFormPassword } from '../routes/user/form/SignUpFormPassword';
import { getErrorMessage } from '../../utils/errorMessage';
import { SignUpError } from '../routes/user/form/SignUpError';
import { SignUpFormTerms } from '../routes/user/form/SignUpFormTerms';
import { validateAutomaticSignup } from '../signup.api';
import '../routes/signup_form.scss';
import {
  ModalConfirmationContainer,
  ModalConfirmationHeaderNoClose,
  ModalConfirmationFooter,
  ModalConfirmationContent,
  ModalActions,
} from '../../components/modal';
import { BrandButton } from '../../components/button';

type State = {
  firstName: string;
  lastName: string;
  password: string;
  loading: boolean;
  agreedToTerms: boolean;
  errorMessage: string;
  errorType: string;
};

type Props = {
  closeModal: () => void;
  isOpen: boolean;
};

export class SignUpValidationModal extends React.Component<Props, State> {
  static defaultProps = {
    closeModal: () => {},
    isOpen: false,
  };

  state: State = {
    firstName: '',
    lastName: '',
    password: '',
    loading: false,
    agreedToTerms: false,
    errorMessage: '',
    errorType: '',
  };

  handleTerms = () => {
    this.setState((state) => ({ agreedToTerms: !state.agreedToTerms }));
  };

  handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = event.target;
    // @ts-ignore ✅
    this.setState({
      [name]: value,
      errorMessage: '',
      errorType: '',
    });
  };

  submitSetPassword = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const { password, agreedToTerms, firstName, lastName } = this.state;
    const res = window.location.pathname.match(
      /signup_validation\/.*\/(?<token>.*)/,
    );
    const verificationToken = res && res.groups ? res.groups.token : '';
    try {
      this.setState({ loading: true });
      await validateAutomaticSignup({
        password,
        agreedToTerms,
        verificationToken,
        firstName,
        lastName,
      });
      window.location.href = '/?source=signup-validation-modal';
    } catch (error) {
      if (error.response && error.response.data) {
        this.setState({
          loading: false,
          errorType: error.response.data.error,
          errorMessage: getErrorMessage(error.response),
        });
      } else {
        throw error;
      }
    }
  };

  render() {
    const { agreedToTerms } = this.state;
    const { isOpen, closeModal } = this.props;
    return (
      <ModalConfirmationContainer
        isOpen={isOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
      >
        <ModalConfirmationHeaderNoClose
          title={
            <FormattedMessage id="signup/signup-validation/SignUpValidationModal.tsx/1" />
          }
        />
        <form onSubmit={this.submitSetPassword}>
          <ModalConfirmationContent>
            <SignUpFormName
              firstName={this.state.firstName}
              lastName={this.state.lastName}
              handleChange={this.handleChange}
            />
            <SignUpFormPassword
              password={this.state.password}
              handleChange={this.handleChange}
            />
            <SignUpFormTerms
              handleTerms={this.handleTerms}
              agreedToTerms={agreedToTerms}
              jobTitle=""
              USER_JOBS={[]}
            />
            {this.state.errorMessage && (
              <SignUpError
                errorMessage={this.state.errorMessage}
                errorType={this.state.errorType}
              />
            )}
          </ModalConfirmationContent>
          <ModalConfirmationFooter>
            <ModalActions>
              <BrandButton disabled={this.state.loading} type="submit">
                {this.state.loading ? 'Envoi en cours...' : 'Valider le compte'}
              </BrandButton>
            </ModalActions>
          </ModalConfirmationFooter>
        </form>
      </ModalConfirmationContainer>
    );
  }
}
